import { type AwsRumConfig } from 'aws-rum-web';

const SESSION_REPLAY_SAMPLE_RATE = 0.1;

/** Only the BFF gets the X-Ray header; third-party hosts would refuse it in their CORS preflight. */
const TRACED_URLS = [/\/bff\//];

/** Cookiebot rejects with this once the account's visit quota is used up; it is not an app error. */
const COOKIEBOT_QUOTA_MESSAGE = 'Visits limit reached';

const rejectionMessage = (reason: unknown): unknown =>
  typeof reason === 'object' && reason !== null && 'message' in reason ? reason.message : reason;

export const isIgnoredError = (event: ErrorEvent | PromiseRejectionEvent): boolean =>
  'reason' in event && rejectionMessage(event.reason) === COOKIEBOT_QUOTA_MESSAGE;

type RumSettings = {
  identityPoolId: string;
  region: string;
};

export const buildRumConfig = ({ identityPoolId, region }: RumSettings): AwsRumConfig => ({
  sessionSampleRate: 1,
  identityPoolId,
  endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
  telemetries: [
    'performance',
    ['errors', { ignore: isIgnoredError }],
    ['http', { addXRayTraceIdHeader: TRACED_URLS }],
    ['replay', { additionalSampleRate: SESSION_REPLAY_SAMPLE_RATE }],
  ],
  allowCookies: true,
  enableXRay: true,
});
